import login from'./view/login'
import router from'./view/router'
import base from'./view/base/index.js'
import sportExercise from './view/sportExercise/index.js'
import sportTest from './view/sportTest/index.js'
import sportsGame from './view/sportsGame/index.js'
import sportEvaluation from './view/sportEvaluation/index.js'
import sportsTeach from'./view/sportsTeach/index.js'
import hm from'./view/hm/index.js'
import resources from'./view/resources/index.js'

export default {
    router,
    views:{
        login,
        sportExercise,
        sportTest,
        sportsGame,
        base,
        sportEvaluation,
        sportsTeach,
        hm,
        resources
    },
    inputRequired:{
        '请填写登录用户名':'Please enter the login username',
        '请填写登录密码':'Please enter the login password',
        '登录密码格式仅支持大小写字母、数字及特殊符号':'The login password format only supports uppercase and lowercase letters, numbers, and special symbols',
        '请填写验证码':'Please enter the verification code',
    },
    inputPlaceholder:{
        '请输入用户名（账号 或 手机号）':'Please enter the username (account or mobile phone number)',
        '请输入密码':'Please enter the password',
        '请输入验证码':'Please enter the verification code',
        '名称/编码模糊搜索':'Fuzzy search by name/code',
    },
    from:{
        '全部':'All',
        '类型':'Type',
        '状态':'Status',
        '请选择状态':'Please select the status',
        '性质':'Nature',
        '搜索':'Search',
        '重置':'Reset',
        '查询':'Query',
        '新增':'Add new',
        '启用':'Enable',
        '停用':'Disable',
        '查看':'View',
        '数据':'Data',
        '编辑':'Edit',
        '删除':'Delete',
        '保存':'Save',
        '操作':'Operation',
        '下载':'Download',
        '备注':'Remarks',
        '返回':'Return',
        '其他':'Other',
        '租户':'Tenant',
        '机构':'Organization',
        '请选择机构':'Please select the organization',
        '联系方式':'Contact information',
        '邮箱':'Email',
        '创建人':'Creator',
        '创建时间':'Creation time',
        '更新时间':'Update time',
        '基本信息':'Basic information',
        '区域':'Area',
        '详细地址':'Detailed address',
        '扩展信息':'Extended information',
        '机构LOGO':'Organization logo',
        '平台LOGO':'Platform logo',
        '域名':'Domain name',
        '通用':'General',
        '项目':'Project',
        '项目名称':'Project name',
        '项目ID':'Project ID',
        '项目状态':'Project status',
        '知道了':'Got it',
        '页':'Page',
        '条':'Item',
        '共计{total}条数据':'A total of {total} data items',
        '取消':'Cancel',
        '下一步':'Next step',
        '上一步':'Previous step',
        '确认':'Confirm',
        '确定':'OK',
        '保存成功！':'Saved successfully!',
        '发布范围':'Release scope',
        '请输入{name}':'Please enter {name}',
        '请选择{name}':'Please select {name}',
        '分':'Minute',
        '秒':'Second',
        '个':'Piece',
        '已启用':'Enabled',
        '已停用':'Disabled',
        '启用':'Enable',
        '停用':'Disable',
        '成功':'Success',
        '失败':'Failure',
        '男':'Male',
        '女':'Female',
        '等级':'Level',
        '暂无':'Not available',
        '结束':'End',
        '重置密码':'Reset password',
        '批量移除':'Batch remove',
        '批量新增':'Batch add',
        '移除':'Remove',
        '全部选择':'Select all',
        '平台':'Platform',
        '点击查看大图':'Click to view the large image',
        '排序':'Sort',
        '发布':'Publish',
        '序号':'Serial number',
        '上移':'Move up',
        '下移':'Move down',
        '学级':'Grade level',
        '请选择学级':'Please select the grade level',
        "院系":'Department',
        "专业":'Major',
        "请选择专业":'Please select the major',
        '班级':'Class',
        '应用终端':'Application terminal',
        '请选择应用终端':'Please select the application terminal',
        '场景':'Scenario',
        '请选择项目':'Please select the project',
        '运动时间':'Exercise time',
        '姓名、学籍号模糊搜索':'Fuzzy search by name and student ID',
        '姓名模糊搜索':'Fuzzy search by name',
        '视频回看':'Video playback',
        '视频预览':'Video preview',
        '所属机构':'Affiliated organization',
        '性别':'Gender',
        '学籍号':'Student ID',
        '锻炼时长':'Exercise duration',
        '测试时间':'Test time',
        '成绩':'Score',
        '运动时间':'Exercise time',
        '学年':'School year',
        '请选择学年':'Please select the school year',
        '（当前学年）':'(Current school year)',
        '学期':'Semester',
        '请选择学期':'Please select the semester',
        '（当前学期）':'(Current semester)',
        '秒':'Second',
        '批量导出':'Batch export',
        '姓名':'Name',
        '得分':'Score',
        '分数':'Grade',
        '管理':'Management',
        '批量操作':'Batch operation',
        '批量导入':'Batch import',
        '标准分':'Standard score',
        '附加分':'Extra score',
        '用户名称':'User name',
        '评分标准':'Scoring criteria',
        '违规':'Violation',
        '照片':'Photo',
        '已上传':'Uploaded',
        '未上传':'Not uploaded',
        '姓名、准考证号模糊搜索':'Fuzzy search by name and admission ticket number',
        '准考证号':'Admission ticket number',
        '报考项目':'Exam subject',
        '用户名搜索':'Search by username',
        '全选（跨页）':'Select all (across pages)',
        '学校':'School',
        '教师':'Teacher',
        '手机号':'Mobile phone number',
        '账号':'Account',
        '用户':'User',
        '关闭':'Close',
        '更多':'More',
        '上传':'Upload',
        '所属项目':'Project',

        '视频':'Video',
        '修改':'Amend',
        '不限': 'unlimited',
        '清空':'Clean',
        '认证':'Identification',
        '运动报告':'Sports Report',

        '详情':'Details',
        //25-8-1
        '操作成功':'Operate successfully',
        '场所':'Place',
        //25-12-19
        '民族':'Nationality',
        //26-1-7
        '有效':'Effective',
        '自由锻炼':'Free Exercise',
        '应用终端':'Application Terminal',
        '竞技场':'Arena',
        '趣味锻炼':'Fun Exercise',
        '是':'Yes',
        '否':'No',
        '时长':'Duration',
        //26-6-16
        '运动结果':'Sports Results',
        '达标状态':'Compliance Status',
        '已达标':'Standards',
        '未达标':'Nonqualified',
    },
    udload:{
        '1、下载导入模版、填写信息':'1. Download the import template and fill in the information',
        '2、上传填写好的文件，导入数据':'2. Upload the filled file and import the data',
        '下载模板':'Download the template',
        '选择文件':'Select a file',
        '导入':'Import',
        '导出':'Export',
        '数据导入中':'Data importing...',
        '下载失败记录':'Download the failure record',
        '重新上传':'Upload again',
        '导入完成':'Import completed',
        '导入成功！':'Imported successfully!',
        '导入失败！':'Import failed!',
        '数据导入成功！':'Data imported successfully!',
        '数据导入失败！':'Data import failed!',
        '失败记录':'Failure record',
        '只能导入Excel表格文件！':'Only Excel spreadsheet files can be imported!',
        '文件上传成功！':'File uploaded successfully!',
        '文件格式不正确，请重新上传！':'The file format is incorrect. Please upload again!',
        '上传中...':'Uploading...',
        '上传中':'Uploading...',
        '点击上传':'Click to upload',
        '请上传文件':'Please upload a file',
        '下载模版':'Download the template',
        '上传图片': 'Upload an image',
        '成绩导入完成':'Score import completed',
        '批量成绩导入失败列表':'Batch result import failure list',
        '姓名,学籍号,失败原因':'Name, student number, reason for failure',
        '文件':'File',
        '请选择运动员':'Please select an athlete',
        '文件大小不符合规范！':'The file size does not conform to the standard!',
        '文件分辨率或大小超出范围！': 'The file resolution or size exceeds the limit!',
        '文件上传中':'File uploading',
        '文件上传完成':'File upload completed',
        '后台数据处理中，成绩导入完成预计3到5分钟（可关闭窗口，不影响导入）':'Background data processing in progress. Score import is estimated to complete in 3 to 5 minutes (you may close the window without affecting the import)',
        '支持上传PNG、JPG格式图片，且图片小于5M':'Supports uploading PNG and JPG images with a file size less than 5MB',
        '支持上传mp4格式，且视频小于2G':'Supports uploading MP4 videos with a file size less than 2GB',
        '支持上传MP3格式，且音频小于20M':'Supports uploading MP3 audio files with a file size less than 20MB',
        '成绩数据导入处理完成':'Score data import processing completed',
    },
    grd:{
        '一年级':'Grade 1',
        '二年级':'Grade 2',
        '三年级':'Grade 3',
        '四年级':'Grade 4',
        '五年级':'Grade 5',
        '六年级':'Grade 6',
        '初 一':'Grade 7',
        '初 二':'Grade 8',
        '初 三':'Grade 9',
        '高 一':'Grade 10',
        '高 二':'Grade 11',
        '高 三':'Grade 12',
        '大 一':'Freshman',
        '大 二':'Sophomore',
        '大 三':'Junior',
        '大 四':'Senior',
    },
    message: {
        '是否返回': 'Do you want to go back',
        '是否返回上一页？': 'Do you want to go back to the previous page?',
        '数据保存成功！': 'Data saved successfully!',
        '新增成功': 'Newly added successfully',
        '服务器出错，请稍后重试': 'The server is experiencing an error. Please try again later.',
        '状态更改成功': 'Status changed successfully',  
        '修改成功': 'Modified successfully',
        '删除成功': 'Deleted successfully',
        '取消后，页面数据不再保存':'After cancellation, the page data will not be saved.',
        '操作成功': 'Operation successful',
        '返回后，页面数据不做保存': 'After returning, the page data will not be saved.',
        '确认要返回吗？': 'Are you sure you want to go back?',
        '请输入内容': 'Please enter the content',
        '内容文本已超过限制字数': 'The content text has exceeded the maximum number of characters.',
        '链接不存在，请重新插入': 'The link does not exist. Please insert it again.',
        '链接必须以': 'The link must start with http/https. Please insert it again.',
        '上传处理异常，请联系管理员': 'An error occurred during the upload process. Please contact the administrator.',
        '图片预览': 'Image preview',
        '音频预览': 'Audio preview',
        '上传图片': 'Upload an image',
        '文件大小不符合规范！': 'The file size does not meet the specifications!',
        '上传文件格式错误！': 'The uploaded file format is incorrect!',
        '文件分辨率或大小超出范围！': 'The file resolution or size exceeds the limit!',
        '上传成功！': 'Uploaded successfully!',

        '文件上传成功！': 'File upload successful!',
        '文件格式不正确，请重新上传！': 'File format is incorrect, please re-upload!',
        '没有任何可用的角色权限信息，请联系管理员处理！':'​No role permissions available. Contact administrator!',
    }
};    